import {BACKEND} from '~/config'
import {invalidateCache, cache} from '~/services/cache/profileCache'
import {handleHttpError} from '~/services/error'
import {http} from '~/utils/http'

import type {HttpResponse} from '~/types/error'
import type {Profile} from '~/types/profile'

export function getProfile() {
    return cache.profile ||= http.get<Profile>(`${BACKEND}/profile`)
        .catch((error: HttpResponse) => {
            handleHttpError(error)
        })
        .catch(error => {
            invalidateCache({})
            throw error
        })
}
